var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAssetsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7277 8.47255C11.4473 7.84509 10.5566 7.84509 10.2763 8.47255L9.71923 9.71923L8.47255 10.2763C7.84509 10.5566 7.84509 11.4473 8.47255 11.7277L9.71923 12.2847L10.2763 13.5314C10.5566 14.1588 11.4473 14.1588 11.7277 13.5314L12.2847 12.2847L13.5314 11.7277C14.1588 11.4473 14.1588 10.5566 13.5314 10.2763L12.2847 9.71923L11.7277 8.47255Z",
    fill: "#00F0FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.998 11.001L19.998 7.00098C19.998 5.34412 18.6549 4.00098 16.998 4.00098L6.99805 4.00098C5.34119 4.00098 3.99805 5.34412 3.99805 7.00098L3.99805 17.001C3.99805 18.6578 5.34119 20.001 6.99805 20.001L10.998 20.001M17.9111 19.9576L18.2302 19.2433C18.4311 18.7937 18.7908 18.434 19.2404 18.2331L19.9546 17.914C20.7441 17.5613 20.7441 16.4407 19.9546 16.088L19.2404 15.7688C18.7908 15.5679 18.4311 15.2083 18.2302 14.7587L17.9111 14.0444C17.5583 13.255 16.4378 13.255 16.085 14.0444L15.7659 14.7587C15.565 15.2083 15.2053 15.5679 14.7557 15.7688L14.0415 16.088C13.252 16.4407 13.252 17.5613 14.0414 17.914L14.7557 18.2331C15.2053 18.434 15.565 18.7937 15.7659 19.2433L16.085 19.9576C16.4378 20.747 17.5583 20.747 17.9111 19.9576Z",
    stroke: "white",
    strokeWidth: 1.1,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssetsIcon);
export default __webpack_public_path__ + "static/media/assetsIcon.8e11aaa102ccc584bfc715c0c90765e1.svg";
export { ForwardRef as ReactComponent };